module.exports = __webpack_public_path__ + "static/media/vf_wbag_core.9353457f.svg";